import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import RouteContext from 'src/routes/context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { setSelectedVariant } from 'src/areas/product/actions/product';
import {
  VariantGroup as VariantGroupType,
  Variant as VariantType,
} from 'src/types';
import { trackProductVariantClick } from 'src/areas/product/components/tracking';
import { Group } from './group';

export const VariantGroups: React.FC<VariantGroupsProps> = ({
  variantGroups,
}) => {
  const { dispatch: routeDispatch } = useContext(RouteContext);

  const dispatch = useDispatch();

  const { filters, selectedCondition } = useContext(PriceListFilterContext);

  const handleSelectedVariant = (
    group: VariantGroupType,
    variant: VariantType | null
  ) => {
    dispatch(setSelectedVariant(variant));
    trackProductVariantClick(group, variant);
    routeDispatch({
      type: 'PRODUCT_VARIANTS',
      variants: variant && variant.id !== 0 ? [variant.id] : null,
      options: { ...filters },
      condition: selectedCondition,
    });
  };

  return (
    <>
      {variantGroups.map(group =>
        group.variants?.length ? (
          <Group
            handleSelectedVariant={handleSelectedVariant}
            group={group}
            key={`${group.type}-${group.id}`}
          />
        ) : null
      )}
    </>
  );
};

interface VariantGroupsProps {
  variantGroups: VariantGroupType[];
}
